// Dependency-free so Playwright tests can import these without loading the
// Designer stores that selectors.ts depends on.

/**
 * Pixel gap between frames when rendering one frame per breakpoint.
 */
export const MCC_ALL_BREAKPOINTS_GAP_PX = 100;
export const MCC_ALL_BREAKPOINTS_VIEWPORT_SCALE = 0.6;
